module.exports = __webpack_public_path__ + "static/Phone2-5f3c490618d7c3dfd4312dfa90de55c9.png";